import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* 404 Content */}
      <main className="flex-1 container mx-auto px-4 flex flex-col items-center justify-center text-center">
        <h2 className="font-serif text-7xl md:text-9xl text-[#B87775]">404</h2>
        <h3 className="font-serif text-2xl md:text-3xl text-gray-800 mt-6">
          Page Not Found
        </h3>
        <p className="max-w-md mt-4 text-gray-600">
          We couldn't find the page you're looking for. The page may have been
          moved, deleted, or never existed.
        </p>

        <div className="mt-12 flex flex-col md:flex-row gap-4">
          <a
            href="/"
            className="flex items-center justify-center gap-2 bg-white border border-[#B87775] text-[#B87775] hover:bg-[#f9f1f1] px-6 py-3 rounded transition-colors"
          >
            <ArrowLeft size={18} />
            Return Home
          </a>
          <a
            href="/booking"
            className="bg-[#B87775] hover:bg-[#a56967] text-white px-6 py-3 rounded transition-colors"
          >
            BOOK A SESSION
          </a>
        </div>
      </main>
    </div>
  );
}
